export const theme = {
    color: {
        // backgrounds
        mainColor: "#0a0a0f",
        bgCard: "#13131c",
        bgCard2: "#1a1a28",
        bgCard3: "#1f1f30",
        // text
        fontMain: "#4f8ef7",
        fontMainHover: "rgba(79,142,247,0.75)",
        fontMainActive: "rgba(79,142,247,0.5)",
        fontAccent2: "#7c5cfc",
        fontSecond: "#f0f0f8",
        fontMuted: "#9090a8",
        fontSubtle: "#5a5a72",
        // status
        green: "#22d3a0",
        greenBg: "rgba(34,211,160,0.1)",
        amber: "#f59e0b",
        amberBg: "rgba(245,158,11,0.1)",
        red: "#ef4444",
        redBg: "rgba(239,68,68,0.1)",
        // borders
        secondColor: "#13131c",
        thirdColor: "rgba(255,255,255,0.06)",
        fourthColor: "rgba(255,255,255,0.04)",
        borderSubtle: "rgba(255,255,255,0.07)",
        borderMid: "rgba(255,255,255,0.12)",
        // glow
        accentGlow: "rgba(79,142,247,0.15)",
    },
    breakPoint: {
        firstBp: 1380,
        secondBp: 1155,
        thirdBp: 767,
    }
};
